import { Box } from '@radix-ui/themes';
import { DigitInput } from '../DigitInput/DigitInput';

export interface TimecodeInputProps {
    value: string;
    onChange: (value: string) => void;
}

const CircleSVG = () => (
    <svg
        width='4'
        height='4'
        viewBox='0 0 4 4'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='2' cy='2' r='1.5' fill='var(--gray-8)' />
    </svg>
);

const TimecodeColon = () => (
    <Box
        style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            margin: '0 4px',
        }}
    >
        <CircleSVG />
        <CircleSVG />
    </Box>
);

const TIMECODE_CAPS = [
    undefined,
    undefined, // Hours: up to 99
    5,
    9, // Minutes: Max 59
    5,
    9, // Seconds: Max 59
];

export const TimecodeInput = ({ value, onChange }: TimecodeInputProps) => {
    const flatValue = value.replace(/:/g, '');

    const handleChange = (newFlatValue: string) => {
        const h = newFlatValue.slice(0, 2);
        const m = newFlatValue.slice(2, 4);
        const s = newFlatValue.slice(4, 6);
        onChange(`${h}:${m}:${s}`);
    };

    const renderSeparator = (index: number) => {
        if (index === 1 || index === 3) return <TimecodeColon />;
        return null;
    };

    return (
        <DigitInput
            length={6}
            value={flatValue}
            onChange={handleChange}
            maxValues={TIMECODE_CAPS}
            renderSeparator={renderSeparator}
        />
    );
};
